module.exports = function getResource(label) {
    const resources = { addPromo: 'Add Promo' };
    return resources[label];
};
